module.exports = __webpack_public_path__ + "static/media/feedback_illust.b8b3794f.svg";